import { AREA_TILES, FALLBACK_CONTENT } from "@/lib/data";

export default function AreasSection({ content }) {
  return (
    <section id="areas" className="bg-[#070b12] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="areas-section">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 min-w-0">
          <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Coverage Map</span>
          <h2 className="font-display uppercase text-white text-[clamp(32px,4vw,52px)] leading-none mb-6">
            South Yorkshire &amp; Surrounds
          </h2>
          <p className="text-sm text-[#93b4d4] mb-8" data-testid="areas-text">
            {content?.areas_text || FALLBACK_CONTENT.areas_text}
          </p>
          <div className="grid grid-cols-2 gap-3 text-xs font-mono-lbl text-[#c8d9ea]">
            {AREA_TILES.map((t) => (
              <div key={t} className="p-3 rounded-lg bg-[#0b1322] border border-white/10">✦ {t}</div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6 min-w-0">
          <figure className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-[#1e9bff]/30" data-testid="areas-map">
            <img
              src={content?.map_image || FALLBACK_CONTENT.map_image}
              alt="Map of South Yorkshire service area"
              className="absolute inset-0 w-full h-full object-cover opacity-70"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#070b12] via-transparent to-transparent" />
            <figcaption className="absolute bottom-6 left-6 text-xs font-mono-lbl uppercase tracking-[0.14em] text-[#1e9bff]">
              South Yorkshire Service Map
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
